export function checkDivisionLink(division: string) {
  if (division === 'IT') {
    return '/tech';
  } if (division === 'OP') {
    return '/operations';
  }
  return '/office';
}
